import React, { useMemo, useState, useEffect } from 'react';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('Project enquiry');
  const [message, setMessage] = useState('');
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const words = ['useful', 'good', 'engaging', 'interesting'];
  const baseText = "Let's make something ";

  useEffect(() => {
    const currentWord = words[currentWordIndex];
    const timeout = setTimeout(() => {
      if (!isDeleting && displayText === currentWord) {
        // Start deleting after a pause
        setTimeout(() => setIsDeleting(true), 2000);
      } else if (isDeleting && displayText === '') {
        // Move to next word
        setIsDeleting(false);
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
      } else {
        // Continue typing or deleting
        setDisplayText(prev => {
          if (isDeleting) {
            return currentWord.substring(0, prev.length - 1);
          } else {
            return currentWord.substring(0, prev.length + 1);
          }
        });
      }
    }, isDeleting ? 50 : 100);

    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, currentWordIndex, words]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('email', email);
      formData.append('reason', reason);
      formData.append('message', message);

      const response = await fetch('https://formspree.io/f/xzddbrol', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      });

      if (response.ok) {
        setSubmitStatus('success');
        // Reset form
        setName('');
        setEmail('');
        setReason('Project enquiry');
        setMessage('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const toAddress = 'info@heretic-studio.co.uk';

  return (
    <div className="contact">
      <section className="contact-hero">
        <div className="wrapper">
          <h1 className="contact-hero__title">
            {baseText}
            <br />
            <span className="contact-hero__word">{displayText}</span>
            <span className="contact-hero__cursor">|</span>
          </h1>
         
        </div>
      </section>
      
      <section className="section contact">
        <div className="wrapper grid-display">
          <div className="row">
            <div className="col-6">
              <div className="contact-card">
                <div className="contact-details mono">
                  <div className="contact-details__row">
                    <span>Email</span>
                    <a className="contact-link" href={`mailto:${toAddress}`}>
                      {toAddress}
                    </a>
                  </div>
                  <div className="contact-details__row">
                    <span>Response</span>
                    <span className="contact-note">Usually within 1–2 business days.</span>
                  </div>
                  <div className="contact-details__row">
                    <span>Location</span>
                    <span className="contact-note">UK / working worldwide.</span>
                  </div>
                  <div className="contact-details__row">
                    <span>Instagram</span>
                    <a className="contact-link" href='https://www.instagram.com/the_heretic_studio/'>
                      @the_heretic_studio
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-6">
              <div className="contact-card">
                <form className="contact-form" onSubmit={onSubmit}>
                  <div className="contact-form__field">
                    <label className="mono" htmlFor="contact-name">Name</label>
                    <input
                      id="contact-name"
                      className="contact-form__input"
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      autoComplete="name"
                    />
                  </div>

                  <div className="contact-form__field">
                    <label className="mono" htmlFor="contact-email">Email</label>
                    <input
                      id="contact-email"
                      className="contact-form__input"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoComplete="email"
                      required
                    />
                  </div>

                  <div className="contact-form__field">
                    <label className="mono" htmlFor="contact-reason">What's this about?</label>
                    <select
                      id="contact-reason"
                      className="contact-form__select"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                    >
                      <option>Project enquiry</option>
                      <option>Collaboration</option>
                      <option>Press</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div className="contact-form__field">
                    <label className="mono" htmlFor="contact-message">Message</label>
                    <textarea
                      id="contact-message"
                      className="contact-form__textarea"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      required
                    />
                  </div>

                  <div className="contact-form__actions">
                    <button 
                      className="contact-form__submit mono" 
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Sending...' : 'Send'}
                    </button>
                    <div className="contact-form__note mono">
                      {submitStatus === 'success' && 'Message sent successfully!'}
                      {submitStatus === 'error' && 'Failed to send. Please try again.'}
                      {!submitStatus && 'Your message will be sent directly.'}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
